module.exports = __webpack_public_path__ + "static/img/10003 (3).5bd91fc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10003 (3).webp
// module id = qIWa
// module chunks = 14